module.exports = __webpack_public_path__ + "img/poster1.6e5a2d5f.jpg";